import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Link, Navigate } from 'react-router-dom';
import Introduction from './components/Introduction';
import Location from './components/Location';
import Speaker from './components/Speaker';
import Register from './components/Register';
import SignupCount from './components/SignupCount';
import Protected from './components/Protected';
import Attendees from './components/Attendees';
import AdminPanel from './components/AdminPanel';
import MyRegistration from './components/MyRegistration';
import Auth from './components/Auth';
import Banner from './components/Banner';
import { AuthProvider, useAuth } from './AuthContext';


function Home(): JSX.Element {
  const { username } = useAuth();

  return (
    <>
      <div className="card">
        <h2>Welcome to the Southeast COG Camping Trip</h2>
        <p>
          The Southeast COG Camping Trip is an event designed for COG Men and,
          if they'd like to bring them, their children. It's a great opportunity
          to get away, connect with brothers in the faith, and enjoy the outdoors together.
        </p>
      </div>
      <Introduction />
      <SignupCount />
      {!username && <Register />}
    </>
  );
}

function AuthPage({ mode = 'login' }: { mode?: 'login' | 'register' }): JSX.Element {
  const { username, loading } = useAuth();
  if (loading) return <div className="card"><p>Loading…</p></div>;
  if (username) return <Navigate to="/" replace />;
  return <Auth initialMode={mode} />;
}

function TopNav(): JSX.Element {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const { username, isAdmin, logout } = useAuth();

  return (
    <nav className="topnav">
      <Link to="/" onClick={closeMenu}><button>Southeast COG Camping</button></Link>

      {/* Signed out there's only one link, so a hamburger would hide a single
          button behind an extra tap. Show it inline instead. */}
      {username && (
        <button
          className="nav-toggle"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(open => !open)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      )}

      <div
        className={
          !username
            ? 'nav-actions inline'
            : menuOpen
            ? 'nav-actions open'
            : 'nav-actions'
        }
      >
        {username ? (
          <>
            <Link to="/my-registration" onClick={closeMenu}><button>My Registration</button></Link>
            {process.env.REACT_APP_ROSTER_URL && (
              <Link to="/attendees" onClick={closeMenu}><button>Who's Coming</button></Link>
            )}
            <Link to="/location" onClick={closeMenu}><button>Location</button></Link>
            {isAdmin && (
              <Link to="/admin" onClick={closeMenu}><button>Approvals</button></Link>
            )}
            <button
              onClick={() => {
                closeMenu();
                logout();
              }}
            >
              Log Out
            </button>
          </>
        ) : (
          <Link to="/login" onClick={closeMenu}><button>Login</button></Link>
        )}
      </div>
    </nav>
  );
}

function App(): JSX.Element {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <TopNav />
          <Banner />

          <main className="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/speaker" element={<Speaker />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/signup" element={<AuthPage mode="register" />} />
              <Route path="/location" element={<Location />} />
              <Route
                path="/my-registration"
                element={
                  <Protected>
                    <MyRegistration />
                  </Protected>
                }
              />
              <Route
                path="/admin"
                element={
                  <Protected>
                    <AdminPanel />
                  </Protected>
                }
              />
              <Route
                path="/attendees"
                element={
                  <Protected>
                    <Attendees />
                  </Protected>
                }
              />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
